export const RING_SURFACES = [
  'Polished',
  'Brushed',
  'Side Brushed',
  'Hammered',
  'Ice Matte',
  'Diagonal Matte',
  'Sand Matte'
]